import React, { ReactElement } from "react";
import PropTypes from "prop-types";
import { translate } from "../../../../infrastructure/translate/localization";

import "./balance-sections.scss";
import showAlertThresholdModal from "../../showAlertThresholdModal";

function GenerateAlert({
  alertThreshold,
  alertThresholdEmails,
}: {
  alertThreshold: string;
  alertThresholdEmails: string[];
}): ReactElement {
  return (
    <>
      <div className="balance-hidden-content balanceSection">
        <div className="cob-btn-group">
          <div>
            <p className="sectionText">
              {translate("my-account-section.when-balance-less-than")}
            </p>
            <p className="infoText">{alertThreshold}</p>
          </div>
        </div>
        <div className="cob-btn-group">
          <div>
            <p className="sectionText">
              {translate("my-account-section.they-will-receive-a-notice")}
            </p>
            <p className="infoText">
              {alertThresholdEmails?.map((email) => (
                <span key={email}>{`${email}, `}</span>
              ))}
            </p>
          </div>
        </div>

        <div className="cob-btn-group right-group">
          <button
            type="button"
            className="linkText"
            onClick={() =>
              showAlertThresholdModal({
                alertThreshold,
                alertThresholdEmails,
              })
            }
          >
            {`${translate("actions.edit")} ${translate(
              "common-messages.notice"
            )}`}
          </button>
        </div>
      </div>
      <div className="line-gray" />
    </>
  );
}

GenerateAlert.propTypes = {
  alertThreshold: PropTypes.number.isRequired,
  alertThresholdEmails: PropTypes.array,
};

GenerateAlert.defaultProps = {
  alertThresholdEmails: [],
};

export default GenerateAlert;
